import React from 'react';
import classNames from 'classnames';

import { Spinner } from 'js/src/components/common/ui/Spinner';

type Props = {
    className?: string;
};

const MediaLibrarySpinner = ({ className }: Props) => {
    return (
        <div className={classNames('container-fluid', className)}>
            <div className="row justify-content-center">
                <div className="col-auto">
                    <Spinner className="color-primary" />
                </div>
            </div>
        </div>
    );
};

export default MediaLibrarySpinner;
